import { BUSINESSCARD_NOTIFICATION, EMAIL_SEND_CRM } from "../actions/types";

const initialState = {
  businessCardNotification: {},
  sendEmailNotification: false,
};

// const initialState = {
//   images: {}, //JSON.parse(localStorage.getItem("images")),
//   pictureNotification: "",
//   pictureError: "",
//   // when we fetch data takes some ms to get
// };

//will later get state from api

export default function (state = initialState, action) {
  let images = state.images;
  switch (action.type) {
    case BUSINESSCARD_NOTIFICATION:
      return {
        ...state,
        businessCardNotification: action.payload,
      };
    case EMAIL_SEND_CRM:
      return {
        ...state,
        sendEmailNotification: action.payload,
      };
    default:
      return state;
  }
}
